<script setup>
import { computed } from "vue";

// First use of defineModel() in this repo (requires Vue 3.4+, available
// here on 3.5) — picked for this two-way numeric pair since it's far less
// boilerplate than defineProps+defineEmits for a plain v-model binding.
const props = defineProps({
  min: { type: Number, required: true },
  max: { type: Number, required: true },
});

const minAge = defineModel("minAge", { type: Number, required: true });
const maxAge = defineModel("maxAge", { type: Number, required: true });

const onMinInput = (value) => {
  const next = Number(value);
  minAge.value = next;
  if (maxAge.value < next) maxAge.value = next;
};

const onMaxInput = (value) => {
  const next = Number(value);
  maxAge.value = next;
  if (minAge.value > next) minAge.value = next;
};

const highlightStyle = computed(() => {
  const span = props.max - props.min;
  const leftPct = ((minAge.value - props.min) / span) * 100;
  const rightPct = ((maxAge.value - props.min) / span) * 100;
  return {
    left: `${leftPct}%`,
    width: `${rightPct - leftPct}%`,
  };
});
</script>

<template>
  <div class="age-range-slider">
    <div class="age-range-track"></div>
    <div class="age-range-highlight" :style="highlightStyle"></div>
    <input class="form-range" type="range" :min="min" :max="max" :value="minAge"
      @input="onMinInput($event.target.value)" />
    <input class="form-range" type="range" :min="min" :max="max" :value="maxAge"
      @input="onMaxInput($event.target.value)" />
  </div>
</template>

<style scoped>
.age-range-slider {
  position: relative;
  height: 1.25rem;
  display: flex;
  align-items: center;
}

.age-range-track,
.age-range-highlight {
  position: absolute;
  top: 50%;
  height: 0.35rem;
  border-radius: 0.25rem;
  transform: translateY(-50%);
  pointer-events: none;
}

.age-range-track {
  left: 0;
  right: 0;
  background-color: var(--bs-border-color, #dee2e6);
}

.age-range-highlight {
  background-color: var(--bs-success, #2dce89);
}

.age-range-slider input[type="range"] {
  position: absolute;
  left: 0;
  width: 100%;
  margin: 0;
  background: transparent;
  pointer-events: none;
}

.age-range-slider input[type="range"]::-webkit-slider-runnable-track {
  background: transparent;
}

.age-range-slider input[type="range"]::-moz-range-track {
  background: transparent;
}

.age-range-slider input[type="range"]::-webkit-slider-thumb {
  pointer-events: auto;
}

.age-range-slider input[type="range"]::-moz-range-thumb {
  pointer-events: auto;
}
</style>
